var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldenActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2A7DE1;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.533 -642.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    rx: 4,
    transform: "translate(-58.533 642.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3,16.364H13.691V3H3ZM3,27.055H13.691V19.037H3Zm13.364,0H27.055V13.691H16.364ZM16.364,3v8.018H27.055V3Z",
    transform: "translate(-57.379 643.621)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenActive);
export default __webpack_public_path__ + "static/media/goldenActive.b8a5cad775672695c6b8f25ee23279ab.svg";
export { ForwardRef as ReactComponent };